import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { useReschedule } from './hooks'
import { ButtonFooter, Footer } from '../atoms'
import type { IEntityAppointment } from '@user/store/scheduling'

interface Props {
  allowActions: boolean
  onCloseMain: () => void
  entityAppointment: IEntityAppointment
  onOpenNestedDialog: (completeView: boolean) => void
  appointmentId: string
}

export function CardFooter(props: Props) {
  const { onOpenNestedDialog, entityAppointment, appointmentId } = props

  const hasLocation = Boolean(entityAppointment.locationId)

  const onReschedule = useReschedule(props)

  const theme = useTheme()

  return (
    <Footer>
      {hasLocation && (
        <ButtonFooter
          color="primary"
          variant="text"
          onClick={onReschedule}
          data-test-id={`reschedule-${appointmentId}`}
        >
          Reschedule
        </ButtonFooter>
      )}
      <ButtonFooter
        variant="text"
        color="primary"
        style={{ marginLeft: theme.spacing(3.2) }}
        onClick={() => onOpenNestedDialog(false)}
        data-test-id={`cancel-appointment-${appointmentId}`}
      >
        Cancel Appointment
      </ButtonFooter>
    </Footer>
  )
}
